export default "__VITE_ASSET__CRme5ODn__"